import PageHeader from "../common/pageHeader/v2";
import Contact from "../components/section/contact";

const ContactPage = () => {
  return (
    <>
      <PageHeader title="contact" subTitle="contact us" />
      <Contact />
    </>
  );
};

export default ContactPage;
